export default __webpack_public_path__ + "static/2273-4a08c34ee9cd956e0352facdeaee640a.gif";